(function(){
     'use strict';

     angular
        .module('appback')
        .factory('AnimalesService', AnimalesService);

    AnimalesService.$inject = ['$http'];

    function AnimalesService($http){

        var service= {
           getAnimalesCentro:getAnimalesCentro,
           getAnaliticas:getAnaliticas,
           getAnaliticasByPaciente:getAnaliticasByPaciente,
           guardarPaciente:guardarPaciente,
           getAnimalByMuestra:getAnimalByMuestra,
           getAnimalById:getAnimalById,
           getMuestrasByAnimal:getMuestrasByAnimal,
           getCategoriasEspecies:getCategoriasEspecies
           
        };

        return service;
 		function getAnimalesCentro(peticionEdicion,filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/peticion/getanimalescentro', { params : { peticionEdicion:peticionEdicion,filtros : filtros,lang_id:lang_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getMuestraAnimalYMuestras(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/peticion/getmuestraanimalymuestras', { params : { lang_id:lang_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function getCategoriasEspecies(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/peticion/getcategoriasespecies', { params : { lang_id:lang_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getAnimalByMuestra(muestra,fields,callback){
             var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
           

            $http.get('/backend/peticion/getanimalbymuestra', { params : { centro_id:fields.centro_id,muestra_id : muestra.id, id_animal:muestra.animal_id,lang_id:lang_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function getAnimalById(animal_id,callback){
             var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
           

            $http.get('/backend/peticion/getanimalbyid', { params : { id_animal:animal_id, lang_id:lang_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }


        function getMuestrasByAnimal(animal,callback){
             var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
           

            $http.get('/backend/peticion/getmuestrasbyanimal', { params : { animal_id : animal.id, centro_id:animal.centro_id, lang_id:lang_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getAnaliticas(peticionEdicion,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/peticion/getanaliticas', { params : { peticionEdicion:peticionEdicion,lang_id:lang_id }}, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getAnaliticasByPaciente(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/peticion/getanaliticas', { params : { filtros:filtros,lang_id:lang_id }}, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function guardarPaciente(newpaciente,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            console.log(newpaciente);
            var data = $.param({
               paciente:JSON.stringify(newpaciente),
               lang_id:lang_id
            });
            $http.post('/backend/peticion/guardarpaciente', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }
    }
})();